import { Header } from './Header';

function App() {
  return (
    <>
    <Header />
      <div className="body-content">
        
        
          <div className="logo-home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 336.35 289.74"><path className="cls-1" d="M303.21,177.87c-2.07-.07-4.15,0-6.23,0H48.43c-1.89,0-3.78,0-5.66-.05-5.39-.21-8.22-3.18-8.94-8.38-1.66-12-8.89-18.21-19.61-16.83-9.73,1.26-15.53,10.2-14,21.58,3,22.06,20.61,37.43,43.35,37.45q113.81.12,227.61,0h7.87l1.42,1.65c-6.07,9-11.82,18.19-18.29,26.87-8.24,11-19.65,15.75-33.45,15.69-40.57-.17-81.15,0-121.73-.09a54.47,54.47,0,0,1-9.55-.79c-10.59-2-18.22-8.35-24.9-16.46-7-8.51-11.07-7.61-13.9-7.66-6.3-.12-11.38,4.52-14.31,7.83A14.9,14.9,0,0,0,41,247.16a15.06,15.06,0,0,0,3.27,10.11c2,2.27,3.93,4.59,5.9,6.87,14.12,16.36,32.18,25.06,53.59,25.29,42.83.47,85.68.35,128.52,0,19.27-.14,36.26-7.11,49.77-21,18.95-19.48,31.37-42.78,38-69.09C323,187.84,315.15,178.26,303.21,177.87Z"/><path className="cls-1" d="M336.11,143.64a42.5,42.5,0,0,0-42.23-37.37c-24.72-.13-49.44,0-74.16,0H56c2.53-4.84,4.36-8.75,6.56-12.44C106,20.61,208.34,13,263.31,78.81c7.55,9,17.31,10.69,25.19,4.26s8.26-17,.49-26C248.42,10.43,197.23-8.79,136.86,3.74,74.15,16.76,34.1,56.3,16.57,118.09c-3.22,11.33,4,21,15.58,21.85,2.62.19,5.28.06,7.92.06H289.73c10,0,11.32,1.14,13,10.73s9,15.44,18.37,14.66C331.49,164.52,337.64,155.63,336.11,143.64Z"/></svg>
            <span>B-</span>MENU
          </div>
          <div className="home">
            <h1>Responsive <b>Burguer menu</b> React y Scss</h1>
            <p className='lead'>Este ejercicio es un menú tipo hamburguesa muy intuitivo, lo más destacable es que tiene submenús con <b>categorías y subcategorías infinitas</b>, hecho con Reacty Sass.</p>
            <p>En muchas ocasiones por necesidades del proyecto necesitas estructurar los contenidos en una innumerable cantidad de categorías y subcategorías.</p>
            <p>Normalmente la navegación móvil en este tipo de sitios se complica y se hace laberíntica al desplegar los submenús hacia abajo con un scroll eterno.</p>
            <p>Por lo que una navegación de pantallas que se desplazan horizontalmente te ayuda a organizar visual y mentalmente la estructura y donde estás en cada momento.</p>
            <p>burguer menu, React, Scss, html...</p>
            
            
            <p>By <i>Titín Colomer</i></p>
        </div>
      </div>
      </>
  );
}

export default App;
